/**
 * vite magic : https://vite.dev/guide/features.html#glob-import
 * output becomes:
 * {
 *  '../../../svg/svgr/icons/design-system/matas/16px/bell.svg': svgComponent,
 *  '../../../svg/svgr/icons/design-system/matas/16px/basket.svg': svgComponent,
 *  etc...
 * }
 */

const icons = import.meta.env.PROD
    ? import.meta.glob<{ default: (props: Record<string, unknown>) => React.ReactSVGElement }>(
          // If production build we exclude base icons
          ['../../../svg/svgr/icons/design-system/**', '!../../../svg/svgr/icons/design-system/base'],
          {
              eager: true,
              query: '?react'
          }
      )
    : import.meta.glob<{ default: (props: Record<string, unknown>) => React.ReactSVGElement }>(
          ['../../../svg/svgr/icons/design-system/**'],
          {
              eager: true,
              query: '?react'
          }
      );

export default icons;
